import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import {
    COLUMNS_SLIDER,
    DEFAULT_EDITOR_VISIBILITY,
    FILM_PLAN_COLUMNS_COUNT_KEY,
    FILM_PLAN_VISIBILITY_KEY,
    type FilmPlanVisibilitySettings,
} from '@/screens/Plan/types';
import { rawNumberStorage, syncJsonStorage } from './storage';

export const actsCountAtom = atom(0);

export const columnsCountAtom = atomWithStorage<number | null>(FILM_PLAN_COLUMNS_COUNT_KEY, COLUMNS_SLIDER.DEFAULT, rawNumberStorage, {
    getOnInit: true,
});

export const filmPlanVisibilityAtom = atomWithStorage<FilmPlanVisibilitySettings>(
    FILM_PLAN_VISIBILITY_KEY,
    DEFAULT_EDITOR_VISIBILITY,
    syncJsonStorage<FilmPlanVisibilitySettings>(),
    { getOnInit: true },
);
